<template>
  <div class="body" @keyup.enter="login">
    <div class="text">
      <el-form class="box" :model="loginForm" :rules="rules" ref="loginForm">
        <!-- 标题 -->
        <el-form-item>
          <div style="color: black; font-size: 25px; font-weight: bold">
            用户登录
          </div>
        </el-form-item>

        <!-- 用户名 -->
        <el-form-item label="用户名：" prop="account" size="small">
          <el-input v-model="loginForm.account" />
        </el-form-item>

        <!-- 密码 -->
        <el-form-item label="密码：" prop="password" size="small">
          <el-input v-model="loginForm.password" type="password" />
        </el-form-item>

        <!-- 服务器选择（新增：本地服务器） -->
        <el-form-item label="服务器：" required>
          <el-radio-group v-model="selectedServer" @change="handleServerChange">
            <el-radio label="northwest">服务器1</el-radio>
            <el-radio label="main">服务器2</el-radio>
            <el-radio label="dev">本地服务器</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 记住密码 -->
        <el-form-item>
          <el-checkbox v-model="checked" @change="saveUser">
            记住密码
          </el-checkbox>
        </el-form-item>

        <!-- 登录按钮 -->
        <el-form-item>
          <el-button type="primary" style="width: 200px" @click="login">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 页脚 -->
    <footer>
      <div>超新芯科技有限公司</div>
      <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">{{ icpText }}</a>
    </footer>
  </div>
</template>

<script>
// 引入 base 模块（管理服务器配置）
import base from "@/api/base";
import { getIcpText } from "@/Utils/siteInfo";

// 引入登录 API
import Auth from "@/api/web/User";

const ACCOUNT_STORAGE_KEY = "account";
const PASSWORD_STORAGE_KEY = "password";
const REMEMBER_PASSWORD_STORAGE_KEY = "rememberPassword";

export default {
  name: "MyLogin",
  data() {
    return {
      // 默认选中上次保存的服务器，否则为服务器1
      selectedServer: "northwest",

      loginForm: {
        account: "",
        password: "",
      },
      rules: {
        account: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 3, max: 10, message: "长度 3-10 字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 3, max: 20, message: "长度 3-20 字符", trigger: "blur" },
        ],
      },
      checked: false,
    };
  },
  computed: {
    icpText() {
      return getIcpText();
    },
  },
  methods: {
    // 切换服务器
    handleServerChange(key) {
      base.setServer(key); // 更新 base 中的 currentServer 并存 localStorage
      this.$message({
        message: `已切换到：${base.currentServer.name}`,
        type: "success",
        offset: 100,
      });
    },

    // 登录方法
    async login() {
      try {
        const res = await Auth.login(
          this.loginForm.account,
          this.loginForm.password
        );

        if (res.error) {
          this.$store.dispatch("addNotification", {
            type: "error",
            title: res.error,
          });
          return;
        }

        this.$store.dispatch("addNotification", {
          type: "success",
          title: res.message,
        });

        this.$store.dispatch("updateUserInfo", {
          role: res.data.identity,
          afField: res.data.afField,
          region: res.data.region,
          fieldId: res.data.fieldId,
          token: res.data.token,
        });

        this.$router.refreshRouter();
        this.$router.push({ name: "NavBar" });

        this.$message({
          message: "登录成功",
          type: "success",
          offset: 100,
        });

        // 保存账号密码（如果勾选）
        if (this.checked) {
          localStorage.setItem(ACCOUNT_STORAGE_KEY, this.loginForm.account);
          localStorage.setItem(PASSWORD_STORAGE_KEY, this.loginForm.password);
          localStorage.setItem(REMEMBER_PASSWORD_STORAGE_KEY, "true");
        } else {
          localStorage.removeItem(ACCOUNT_STORAGE_KEY);
          localStorage.removeItem(PASSWORD_STORAGE_KEY);
          localStorage.removeItem(REMEMBER_PASSWORD_STORAGE_KEY);
        }
      } catch (err) {
        console.error("登录请求失败:", err);
        this.$message.error("网络错误，请检查服务器是否可达");
      }
    },

    // 保存账号密码状态
    saveUser() {
      if (!this.checked) {
        localStorage.removeItem(ACCOUNT_STORAGE_KEY);
        localStorage.removeItem(PASSWORD_STORAGE_KEY);
        localStorage.removeItem(REMEMBER_PASSWORD_STORAGE_KEY);
      }
    },

    // 检查版本（可选）
    async checkVersion() {
      const lastReloadTime =
        Number(localStorage.getItem("lastReloadTime")) || 0;
      const currentVersion = localStorage.getItem("website_version");
      const now = Date.now();

      try {
        const res = await Auth.getVersion();
        const newVersion = res.data;

        if (newVersion !== currentVersion && now - lastReloadTime > 3600000) {
          localStorage.setItem("lastReloadTime", now.toString());
          localStorage.setItem("website_version", newVersion);
          window.location.reload();
        }
        document.title = `数据网站 V${newVersion}`;
      } catch (err) {
        console.error("版本检查失败:", err);
      }
    },
  },
  mounted() {
    // 2. 恢复上次选择的服务器
    const saved = localStorage.getItem("selectedServer");
    console.log(saved);
    this.selectedServer = base.SERVER_OPTIONS[saved] ? saved : "northwest"; // 同步到 radio 显示
    base.setServer(this.selectedServer); // 确保 base 使用正确地址

    // 3. 恢复账号密码
    this.checked =
      localStorage.getItem(REMEMBER_PASSWORD_STORAGE_KEY) === "true";
    this.loginForm.account = localStorage.getItem(ACCOUNT_STORAGE_KEY) || "";
    this.loginForm.password = this.checked
      ? localStorage.getItem(PASSWORD_STORAGE_KEY) || ""
      : "";

    // 4. 自动登录（可选）
    /*if (this.loginForm.account && this.loginForm.password) {
      this.login();
    }*/

    // 5. 清空会话
    sessionStorage.clear();

    // 6. 检查版本
    this.checkVersion();
  },
};
</script>

<style lang="less" scoped>
.body {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    125deg,
    #409eff,
    #3fc1c9,
    #0466d5,
    #66b1ff,
    #80d0c7
  );
  background-size: 500%;
  animation: bgAnimation 15s linear infinite;
}

.text {
  color: #fff;
  font-size: 30px;
}

@keyframes bgAnimation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.box {
  display: inline-block;
  width: 400px;
  height: 460px;
  background: rgb(255, 255, 255, 80%);
  border-radius: 20px;
  padding: 15px;
  box-shadow: 0px 0px 10px #363636;
}

footer {
  position: absolute;
  bottom: 5px;
  text-align: center;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
}

footer a {
  color: inherit;
  text-decoration: none;
}
</style>
